export { default as EditInvestment } from './EditInvestment';
